import { formatGr } from '@odhaczka/core';
import { useLiveQuery } from 'dexie-react-hooks';
import { useState } from 'react';
import { Link } from 'react-router';
import { articleName } from '../../data/prices';
import { PROMO_SOURCE, promoShort, usePromoIndex } from '../../data/promotions';
import { db } from '../../db/db';
import type { ArticleRow, PromotionRow } from '../../db/types';
import { cardCls, sectionTitleCls } from '../ui/classes';

const SHOWN = 6;

/** Zakładka Ceny: promocje trwające teraz na produkty, które kupujecie w Lidlu. */
export function PromosSection() {
  const promos = usePromoIndex();
  const [all, setAll] = useState(false);
  const articles = useLiveQuery(async () => {
    const ids = [...new Set((promos?.active ?? []).map((p) => p.articleId).filter((a): a is string => !!a))];
    return new Map((await db.articles.bulkGet(ids)).filter((a): a is ArticleRow => !!a).map((a) => [a.id, a]));
  }, [promos]);
  if (!promos || promos.active.length === 0 || !articles) return null;
  // Jedna pozycja na artykuł (gazetka i kupon na to samo masło razem).
  const groups = new Map<string, PromotionRow[]>();
  for (const p of promos.active) if (p.articleId) groups.set(p.articleId, [...(groups.get(p.articleId) ?? []), p]);
  const entries = [...groups];
  const shown = all ? entries : entries.slice(0, SHOWN);
  return (
    <section id="promos" className="flex flex-col gap-2">
      <h2 className={sectionTitleCls}>Promocje na Wasze produkty ({entries.length})</h2>
      <ul className={`${cardCls} divide-y divide-stone-200 dark:divide-stone-800`}>
        {shown.map(([articleId, ps]) => {
          const a = articles.get(articleId);
          const best = ps[0]!;
          return (
            <li key={articleId}>
              <Link to={`/articles/${encodeURIComponent(articleId)}`} className="flex items-center gap-3 px-4 py-3 active:bg-stone-50 dark:active:bg-stone-800">
                <span aria-hidden className="shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800 dark:bg-amber-900/40 dark:text-amber-200">
                  %
                </span>
                <div className="min-w-0 flex-1">
                  <div className="truncate font-medium">{a ? articleName(a) : best.title}</div>
                  <div className="truncate text-sm text-stone-500">
                    {promoShort(best)} · {PROMO_SOURCE[best.source ?? ''] ?? ''}
                    {ps.length > 1 ? ` (+${ps.length - 1})` : ''}
                  </div>
                </div>
                {best.priceGr ? (
                  <div className="shrink-0 text-right">
                    <div className="font-semibold tabular-nums">{formatGr(best.priceGr)}</div>
                    {best.oldPriceGr ? <div className="text-xs text-stone-500 line-through tabular-nums">{formatGr(best.oldPriceGr)}</div> : null}
                  </div>
                ) : null}
              </Link>
            </li>
          );
        })}
      </ul>
      {!all && entries.length > SHOWN && (
        <button type="button" onClick={() => setAll(true)} className="min-h-10 self-start text-sm font-medium text-brand-700 dark:text-brand-500">
          Pokaż wszystkie ({entries.length})
        </button>
      )}
    </section>
  );
}
